import { Inject, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { PrimeNGConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { es as localeEs } from './es.json';
import { en as localeEn } from './en.json';
import { de as localeDe } from './de.json';
import { fr as localeFr } from './fr.json';
import { it as localeIt } from './it.json';
// import { DialogService } from 'primeng/dynamicdialog';
// import { DialogModule } from 'primeng/dialog';
// import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // DialogModule,
    // ConfirmDialogModule
  ],
  providers: [
    MessageService,
    // DialogService,
    // ConfirmationService
  ],
})
export class ComponentsConfigModule {
  constructor(
    // private primengConfig: PrimeNGConfig,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.configurePrimeNG();
    // this.primengConfig.setTranslation(this.getLocale());
  }

  configurePrimeNG() {
    // this.primengConfig.ripple = true;
  }

  private getLocale(): any {
    switch (this.locale) {
      case 'es':
        return localeEs;
      case 'de':
        return localeDe;
      case 'fr':
        return localeFr;
      case 'en':
        return localeEn;
      case 'it':
        return localeIt;
      default:
        return localeEn;
    }
  }
}
